import { useEffect, useState } from "react";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
import { useNavigate } from "react-router-dom";

//PROJECT IMPORTS
import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import "../../../assets/styles/DatePicker.css";
import CustomButton from "../../../components/custom/CustomButton";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";

import { apiConfig, labelConfig, staticConfig } from "../teller.config";
import dayjs from "dayjs";

const { Title } = Typography;
const { TextArea } = Input;

const NewChequeWithdrawal = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);
  const [accountId, setAccountId] = useState("");

  useEffect(() => {
    form.setFieldValue("transactionDate", dayjs());
    getPaymentTypes();
  }, []);

  const getPaymentTypes = () => {
    let body = {
      session,
    };

    const url = `${apiConfig.PaymentTypes}`;

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempPaymentTypeOptions = [];

        objList?.forEach((element) => {
          tempPaymentTypeOptions.push({
            value: element?.id,
            label: element?.name,
          });
        });

        setPaymentTypeOptions(tempPaymentTypeOptions);
        setIsLoading(false);
      }
    });
  };

  function getAccountDetails(accountNo) {
    if (!accountNo) return;

    setIsLoading(true);
    const url = `${apiConfig.savingsAccountsTeller}/account/${accountNo}?associations=all`;

    BOM.FetchReqAction({ session }, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage || err);
        setIsLoading(false);
      } else {
        setAccountId(res?.id);
        setIsLoading(false);
      }
    });
  }

  function onCancel() {
    navigate("/tlo1100", { replace: false });
  }

  const onSubmit = (values) => {
    const payload = {
      ...values,
      fromAccountId: accountId,
      transactionDate: BOM.DateTime(values?.transactionDate, "only-date"),
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      method: "POST",
      session,
    };

    setIsLoading(true);

    const url = `${apiConfig.Cheques}/chequeleaves/cash-withdraw`;
    BOM.FetchReqAction(payload, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Cheque withdrawn successfully");
        form.resetFields();
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.newChequeWithdrawal}
        pageItems={staticConfig.newChequeWithdrawalItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.withdrawalSetup}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.accountNo}
                  name="accountNumber"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.accountNo),
                    },
                  ]}
                >
                  <Input
                    style={{ height: 44, width: "100%" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.accountNo,
                    )}
                    onBlur={(e) => getAccountDetails(e.target.value)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.paymentType}
                  name="paymentTypeId"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.paymentType),
                    },
                  ]}
                >
                  <Select
                    style={{ height: 44, width: "100%" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.paymentType}`,
                      "select",
                    )}
                    showSearch
                    options={paymentTypeOptions}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.routingCode}
                  name="routingCode"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.routingCode),
                    },
                  ]}
                >
                  <Input
                    style={{ height: 44, width: "100%" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.routingCode,
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.bankNumber}
                  name="bankNumber"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.bankNumber),
                    },
                  ]}
                >
                  <Input
                    style={{ height: 44, width: "100%" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.bankNumber,
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.receiptNumber}
                  name="receiptNumber"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.receiptNumber),
                    },
                  ]}
                >
                  <Input
                    style={{ height: 44, width: "100%" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.receiptNumber,
                    )}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.chequeNo}
                  name="chequeNo"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.chequeNo),
                    },
                  ]}
                >
                  <Input
                    style={{ height: 44, width: "100%" }}
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.chequeNo)}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.transactionDate}
                  name="transactionDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.transactionDate),
                    },
                  ]}
                >
                  <DatePicker
                    style={{ marginBottom: 0, width: "100%" }}
                    placeholder="Select date"
                    suffixIcon={<CalendarIcon color="#667085" width={20} />}
                    className="bond-date-picker custom-input"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.transactionAmount}
                  name="transactionAmount"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.transactionAmount),
                    },
                  ]}
                >
                  <InputNumber
                    style={{ height: 44, width: "100%" }}
                    placeholder={0}
                    formatter={(v) =>
                      `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(v) => v?.replace(/,/g, "")}
                  />
                </Form.Item>
              </Col>
              <Col span={24} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.note}
                  name="note"
                  rules={[
                    {
                      required: true,
                      message: "Note is required",
                    },
                  ]}
                >
                  <TextArea
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.note)}
                    style={{ height: "128px" }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#15CCAE"
                colorText="black"
                hoverBackground="#4FECA0"
              />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(NewChequeWithdrawal);
